import { apiFetch } from './client';

const BASE = '/klaviyo-catalog-sync-jobs';

/**
 * List catalog sync jobs for the authenticated client, most-recent first.
 * Optionally filter by status (e.g. 'in_progress', 'completed', 'failed').
 */
export const list = ({ status, signal } = {}) =>
  apiFetch(status ? `${BASE}?status=${encodeURIComponent(status)}` : BASE, { signal });

/** Get one catalog sync job by id. */
export const get = (id, { signal } = {}) => apiFetch(`${BASE}/${id}`, { signal });

/**
 * Start a catalog sync for the caller's own Klaviyo subscription. No body --
 * the server resolves the subscription from the caller's tenant. Returns 201.
 */
export const create = ({ signal } = {}) => apiFetch(BASE, { method: 'POST', signal });
